import { render, staticRenderFns } from "./LogoButton.vue?vue&type=template&id=ffefa376&"
import script from "./LogoButton.vue?vue&type=script&lang=js&"
export * from "./LogoButton.vue?vue&type=script&lang=js&"
import style0 from "./LogoButton.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports